import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { WITHOUT_SYSTEM, WITH_SYSTEM } from '../data/content';
export function Comparison() {
  return <section className="w-full bg-cream py-20 sm:py-24" data-id="element-47" data-mp="1l6vw3j38doyo">
      <div className="mx-auto max-w-5xl px-5" data-id="element-48" data-mp="1l5b2bvoqqa1v">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-49" data-mp="1pydy8agzpvl8">
          <p className="text-sm font-semibold uppercase tracking-widest text-clay" data-id="element-50" data-mp="1pzyv46qs1qm9">
            El costo de no tener un sistema
          </p>
          <h2 className="mt-3 font-serif text-3xl font-semibold text-ink sm:text-4xl" data-id="element-51" data-mp="1zvin4i28055q">
            El próximo lunes podés improvisar otra vez… o tenerlo resuelto
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-52" data-mp="28x8exp00l641">
          <Reveal className="rounded-2xl border border-sand bg-sand/50 p-7" data-id="element-53" data-mp="28um85rky6umv">
            <h3 className="mb-5 flex items-center gap-2 font-serif text-xl font-semibold text-ink/70" data-id="element-54" data-mp="9lp5786vzttb">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-clay/12 text-clay" data-id="element-55" data-mp="ej7fp30jyh3f">
                <XIcon className="h-4 w-4" data-id="element-56" data-mp="1m2tqxo0e9yu2" />
              </span>
              Sin Yoga 360
            </h3>
            <ul className="space-y-3" data-id="element-57" data-mp="1h85wz9mmgc83">
              {WITHOUT_SYSTEM.map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-muted" data-id="element-58" data-mp="1d6az6f3wggz2">
                  <XIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-clay/60" data-id="element-59" data-mp="18b5f7lu25cdm" />
                  <span data-id="element-60" data-mp="24ya3ppv3ws3b">{item}</span>
                </li>)}
            </ul>
          </Reveal>

          <Reveal delay={0.1} className="rounded-2xl border-2 border-sage/30 bg-sage-deep p-7 text-cream shadow-lg shadow-sage-deep/15" data-id="element-61" data-mp="20yho4t7aplog">
            <h3 className="mb-5 flex items-center gap-2 font-serif text-xl font-semibold" data-id="element-62" data-mp="1r0ljmk8v5ozb">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-cream/15 text-cream" data-id="element-63" data-mp="kk0058vxyo4d">
                <CheckIcon className="h-4 w-4" data-id="element-64" data-mp="fjlpdj2yh02n" />
              </span>
              Con Yoga 360
            </h3>
            <ul className="space-y-3" data-id="element-65" data-mp="h33u5xepmb8x">
              {WITH_SYSTEM.map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-cream/90" data-id="element-66" data-mp="lzu92hes30sr">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-cream" data-id="element-67" data-mp="81x8zb148c9c" />
                  <span data-id="element-68" data-mp="czywq99hkzr5">{item}</span>
                </li>)}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>;
}